import { StyleSheet } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  flex1: {
    flex: 1,
  },
  marginBetweenComponents: {
    marginTop: 32,
  },
  marginBetweenTitle: {
    marginTop: 20,
  },
  // it will show bottom of shadow + content shouldn't end at the end of mobile screen (default system buttons may overlay it)
  lastComponent: {
    marginBottom: 32,
  },
  currentBillPaymentDueDate: {
    backgroundColor: 'transparent',
    marginVertical: 4,
    marginStart: 'auto',
  },
  showMoreTextStyle: theme => ({
    fontSize: 16.6,
    lineHeight: 22,
    textAlign: 'center',
    color: theme.colors.showMoreColor,
  }),
  headerStyle: theme => ({
    backgroundColor: theme.colors.cardBackgroundColorThree,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.borderColorFour
  }),
  container: theme => ({
    color: theme.colors.backgroundColorThree,
    paddingBottom: '10%'
  }),
  flatListFooterStyle: {
    marginTop: 17,
    backgroundColor: Colors.cloud,
  },
  flatListLastItemStyle: {
    marginTop: 17,
  },
  marginForHeadline: {
    marginTop: 15,
  },
  manageSpeedHeadLine: theme => ({
    fontSize: 24,
    color: theme.colors.textColorThree,
    ...Fonts.type.bold,
  }),
  flatListContainerStyle: withShowMore => ({
    marginBottom: withShowMore ? 17 : 32,
  }),
  loadingContainerStyle: theme => ({
    marginTop: 20,
    backgroundColor: theme.colors.cardBackgroundColorThree,
    padding: 15,
    borderRadius: 6,
  }),
  scrollViewContentContainerStyle: {
    paddingBottom: 100,
  },
  errorPreviousBillsIconStyle: {
    marginTop: 16.6,
  },
  errorPreviousBillShowMoreIconStyle: { marginTop: 0, width: 70, height: 70 },
  errorPreviousBillsBackgroundStyle: { height: 250 },
  boldText: theme => ({
    color: theme.colors.textColorThree,
  }),
  currentBillTitle: theme => ({
    fontSize: 24,
    marginTop: 12,
    color: theme.colors.headerColor,
    ...Fonts.type.bold,
  }),
  paidDate: theme => ({
    paddingVertical: 4,
    fontSize: 16,
    color: theme.colors.textColorTwo,
  }),
  previousBillTitle: theme => ({
    fontSize: 24,
    color: theme.colors.textColorThree,
    ...Fonts.type.bold,
  }),
  previousBillSubTitle: theme => ({
    fontSize: 16,
    color: theme.colors.textColorEight,
    marginTop: 16,
  }),
  errorAllBillsIconStyle: {
    justifyContent: 'center',
  },
  errorAllBillsTextStyle: theme => ({
    color: theme.colors.textColorEight,
  }),
  cardStyle: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    paddingVertical: 15,
    shadowColor: Colors.blackThree,
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.16,
    shadowRadius: 8,
    elevation: 4,
    marginTop: 20,
  }),
  errorPreviousBillsShowMoreBackgroundStyle: {
    height: 150,
    backgroundColor: Colors.cardBackgroundColor,
  },
  errorPreviousBillsShowMoreText: { marginBottom: 10 },
  indicatorsContainer: {
    flexDirection: 'row',
    marginTop: 30,
    paddingHorizontal: '10%'
  },
  indicatorItem: {
    flexDirection: 'row',
    alignItems: 'baseline',
    marginRight: 16
  },
  indicatorPoint: color => ({
    width: 15,
    height: 15,
    marginRight: 10,
    backgroundColor: color,
    borderRadius: 15
  }),
  indicatorText: {
    fontSize: Fonts.size.regular
  },
});
